import ibiza from '../../assets/Ibiza_banner.jpg'

const IbizaEventPage = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        // Deep teal-blue gradient matching the sky and water in the banner
        background: 'linear-gradient(160deg, #0d1f2d 0%, #0a2a35 40%, #0d3040 70%, #0b2030 100%)',
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "16px",
        boxSizing: "border-box",
        overflowX: "hidden",
      }}
    >
      {/* Ambient glow — top, mimicking the sky blue haze */}
      <div
        style={{
          position: "fixed",
          top: "-120px",
          left: "50%",
          transform: "translateX(-50%)",
          width: "700px",
          height: "350px",
          background: "radial-gradient(ellipse at center, rgba(100,180,230,0.15) 0%, transparent 70%)",
          pointerEvents: "none",
          zIndex: 0,
        }}
      />

      {/* Ambient glow — bottom left, mimicking the green coastal hillside */}
      <div
        style={{
          position: "fixed",
          bottom: "-80px",
          left: "0",
          width: "400px",
          height: "300px",
          background: "radial-gradient(ellipse at center, rgba(40,100,60,0.18) 0%, transparent 70%)",
          pointerEvents: "none",
          zIndex: 0,
        }}
      />

      {/* Ambient glow — bottom right, teal water reflection */}
      <div
        style={{
          position: "fixed",
          bottom: "-60px",
          right: "0",
          width: "400px",
          height: "280px",
          background: "radial-gradient(ellipse at center, rgba(20,110,120,0.18) 0%, transparent 70%)",
          pointerEvents: "none",
          zIndex: 0,
        }}
      />

      {/* Banner image */}
      <div
        style={{
          position: "relative",
          zIndex: 1,
          width: "100%",
          maxWidth: "680px",
          touchAction: "pinch-zoom",
        }}
      >
        <img
          src={ibiza}
          alt="Afrodise Ibiza Residency 2026"
          style={{
            width: "100%",
            display: "block",
            borderRadius: "12px",
            touchAction: "pinch-zoom",
          }}
        />
      </div>
    </div>
  );
};

export default IbizaEventPage;